import { Alert, Anchor, Container, Group, Text } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { isEmailConfirmationRequired } from '@/lib/utils'
import { useAuth } from '@/providers/AuthProvider'

export default function EmailConfirmationAlert({ siteData }: { siteData?: any }) {
  // Hooks
  const router = useRouter()
  const { isEmailConfirmed } = useAuth() || {}

  // Constants
  const showEmailConfirmationAlert =
    isEmailConfirmationRequired(siteData?.requireEmailConfirmation, isEmailConfirmed) &&
    !router.asPath.includes('/accounts/confirm-email')

  if (!showEmailConfirmationAlert) return null

  return (
    <Alert color="orange" radius={0}>
      <Container size="xl">
        <Group position="apart" spacing="xs">
          <Group spacing="xs" align="center">
            <IconAlertCircle color="orange" size={16} />
            <Text>Confirme seu e-mail para continuar acessando a loja.</Text>
          </Group>
          <Anchor
            component={Link}
            weight={600}
            color="orange"
            href={{ pathname: '/accounts/confirm-email', query: { callbackUrl: router.asPath } }}>
            Confirmar e-mail
          </Anchor>
        </Group>
      </Container>
    </Alert>
  )
}
